import { render, staticRenderFns } from "./Indexadd.vue?vue&type=template&id=5c037c8a&scoped=true"
import script from "./Indexadd.vue?vue&type=script&lang=js"
export * from "./Indexadd.vue?vue&type=script&lang=js"
import style0 from "./Indexadd.vue?vue&type=style&index=0&id=5c037c8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c037c8a",
  null
  
)

export default component.exports